import { Link } from 'react-router-dom';
import { Typography } from 'uiKit/atoms/Typography/Typography';
import { Paragraph } from 'uiKit/atoms/Typography/components/Paragraph';
import DocumentModalContent from './DocumentModalContent';

type TermsAgreementProps = {
  open: boolean;
  closeHandlerOne: () => void;
  agreeHandlerOne: () => void;
};

export const TermsAgreement = ({ open, closeHandlerOne, agreeHandlerOne }: TermsAgreementProps) => (
  <DocumentModalContent
    title="Terms and Conditions"
    open={open}
    agreeHandler={agreeHandlerOne}
    closeHandler={closeHandlerOne}
  >
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      General
    </Typography>
    <Paragraph>
      {'The '}
      <Link to="/" target="_blank" rel="noopener noreferrer" className="decorated">
        https://bns.dataart.com/
      </Link>
      website (“Website”, “Service”) is operated by DataArt Solutions, Inc (“DA”, “us,” or “we”). Access and use of the
      Service is subject to the following Terms and Conditions of Service (“Terms and Conditions”). By accessing or
      using any part of the Service, you represent that you have read, understood, and agree to be bound by these Terms
      and Conditions including any future modifications. DA may amend, update or change these Terms and Conditions. If
      we do this, we will post a notice about changes made to these Terms and Conditions on the Website. If you do not
      agree to abide by these Terms and Conditions, you are not authorized to use, access or participate in the Service.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Description of website and service{' '}
    </Typography>
    <Paragraph>
      {`The Service is a marketplace that enables users to list, sell and purchase legally compliant items and services
      at any time, from anywhere and at any price. DA may, in its sole discretion and at any time, update, change,
      suspend, make improvements to or discontinue any aspect of the Service, temporarily or permanently.`}
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Registration{' '}
    </Typography>
    <Paragraph> In connection with login and using the Service, you agree: </Paragraph>
    <Paragraph className="pl-30 mb-0">
      1. to provide accurate and current information about the items posted on the Website;
    </Paragraph>
    <Paragraph className="pl-30">
      2. to be fully responsible for all use of your account and for any actions that take place through your account.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Your representations and warranties{' '}
    </Typography>
    <Paragraph>
      {' '}
      You represent and warrant to DA that your access and use of the Service will be in accordance with these Terms and
      Conditions and with all applicable laws, rules and regulations of the United States and any other relevant
      jurisdiction, including those regarding online conduct or acceptable content, as well as the transmission of data
      or information exported from the United States and/or the jurisdiction in which you reside. If you login to the
      Website, you further represent and warrant that you are login for the Website for the express purpose of using
      Services as set above in Section ‘Description of website and service’. You further represent and warrant that you
      will carefully safeguard your password, user name, and account information, will not share your password or user
      name with any third party, and will not allow any third party to access your Website account for any purpose.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      Inappropriate use{' '}
    </Typography>
    <Paragraph>
      {' '}
      You will not upload, display or otherwise provide on or through the Service any content that: (i) is libelous,
      defamatory, abusive, threatening, harassing, hateful, offensive or otherwise violates any law or infringes upon
      the right of any third party (including copyright, trademark, privacy, publicity or other personal or proprietary
      rights); or (ii) in DA’s sole judgment, is objectionable or which may expose DA or its users to any harm or
      liability of any kind. You will use the Website in compliance with applicable&nbsp;
      <Link
        to="https://info.dataart.com/index.php?title=Category:Policies"
        target="_blank"
        rel="noopener noreferrer"
        className="decorated"
      >
        {'DataArt policies'}
      </Link>
      . You will not sell and will promptly remove all listings for any product if the sale of the product is prohibited
      by law or regulation or the product poses a health or safety hazard as specified by any governmental agency. DA
      has no responsibility or liability for the safety or performance of any product that you list or sell using the
      Service.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Indemnification of DA{' '}
    </Typography>
    <Paragraph>
      You agree to defend, indemnify and hold harmless DA, its affiliates and its directors, officers, employees,
      contractors, agents, suppliers, licensors, successors and assigns, from and against any and all losses, claims,
      causes of action, obligations, liabilities and damages whatsoever, arising out of or relating to your access to or
      use of the Service (as part of these Terms and Conditions or otherwise), your breach of any of these Terms and
      Conditions, inter alia, your representations and warranties.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      No representations or warranties by DA{' '}
    </Typography>
    <Paragraph>
      The Service, including all images, and other content therein, and any other information, property and rights
      granted or provided to you by DA are provided to you on an “as is” basis. The quality, safety, legality and
      compliance of a product or service with their description, as well as the ability of the user to sell or buy a
      product or service are beyond the control of DA. DA and its suppliers make no representations or warranties of any
      kind with respect to the Service, either express or implied, and all such representations and warranties,
      including warranties of fitness for a particular purpose or non-infringement, are expressly disclaimed. Without
      limiting the generality of the foregoing, DA does not make any representation or warranty of any kind relating to
      accuracy, Service availability, completeness, informational content, error-free operation, results to be obtained
      from use, or non-infringement. Access and use of the Service may be unavailable during periods of peak demand,
      system upgrades, malfunctions or scheduled or unscheduled maintenance or for other reasons. Some jurisdictions do
      not allow the exclusion of implied warranties, so the above exclusion may not apply to you.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Limitation on types of damages/ Limitation of liability{' '}
    </Typography>
    <Paragraph>
      In no event will DA be liable to you or any third party claiming through you (whether based in contract, tort,
      strict liability or other theory) for indirect, incidental, special, consequential or exemplary damages arising
      out of or relating to the access or use of, or the inability to access or use, the Service or any portion thereof,
      including but not limited to the loss of use of the Service, inaccurate results, loss of profits, business
      interruption, or damages stemming from loss or corruption of data or data being rendered inaccurate, the cost of
      recovering any data, the cost of substitute services or claims by third parties for any damage to computers,
      software, modems, telephones or other property, even if DA has been advised of the possibility of such damages.
      DA’s liability to you or any third party claiming through you for any cause whatsoever, and regardless of the form
      of the action, is limited to the total amount of $ 1,000. This is an aggregate limit. The existence of more than
      one claim hereunder will not increase this limit.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      Termination{' '}
    </Typography>
    <Paragraph>
      You may terminate your Website account at any time upon request. The provisions of these Terms and Conditions
      relating to the protection and enforcement of DA’s proprietary rights, your representations and warranties,
      disclaimer of representations and warranties, indemnities, limitations of liability and types of damages,
      ownership of data and information, governing law and venue, and miscellaneous provisions shall survive any such
      termination.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Trademarks{' '}
    </Typography>
    <Paragraph>
      “DataArt” and all other trademarks, service marks, graphics and logos used in connection with the Service are
      trademarks or service marks of DA or their respective owners, and certain of them are registered with the United
      States Patent and Trademark Office. Access and use of the Service does not grant or provide you with the right or
      license to reproduce or otherwise use the DA name or any DA or third-party trademarks, service marks, graphics or
      logos.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Privacy{' '}
    </Typography>
    <Paragraph>
      Use of the Service is also governed by our Privacy Policy, a copy of which is located at&nbsp;
      <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="decorated">
        https://bns.dataart.com/privacy/
      </Link>
      . By using the Service, you consent to the terms of the Privacy Policy.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Governing law and legal proceeding{' '}
    </Typography>
    <Paragraph>
      {' '}
      These Terms and Conditions, its subject matter and DA’s and your respective rights under these Terms and
      Conditions shall be governed by and construed under the laws of the state of New York, United States of America,
      excluding the conflict of law provisions of that or any other jurisdiction. Unless otherwise expressly required by
      applicable law, each party shall bear its own attorneys’ fees without regard to which party is deemed the
      prevailing party in the proceeding.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Miscellaneous{' '}
    </Typography>
    <Paragraph>
      These Terms and Conditions constitute the entire agreement between DA and you concerning the subject matter
      hereof. In the event that any of the Terms and Conditions are held by a court or other tribunal of competent
      jurisdiction to be unenforceable, such provisions shall be limited or eliminated to the minimum extent necessary
      so that these Terms and Conditions shall otherwise remain in full force and effect. A waiver by DA or you of any
      provision of these Terms and Conditions or any breach thereof, in any one instance, will not waive such term or
      condition or any subsequent breach thereof. DA may assign its rights or obligations under these Terms and
      Conditions without condition. These Terms and Conditions will be binding upon and will inure to the benefit of DA
      and you, and DA’s and your respective successors and permitted assigns.
    </Paragraph>
  </DocumentModalContent>
);
